import { render, staticRenderFns } from "./Segments.html?vue&type=template&id=310f4e72&scoped=true&"
import script from "./Segments.js?vue&type=script&lang=js&"
export * from "./Segments.js?vue&type=script&lang=js&"
import style0 from "./Segments.scss?vue&type=style&index=0&id=310f4e72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310f4e72",
  null
  
)

export default component.exports